// test1744
(1744 && 0);
